import { atom } from "recoil";

export const CostDetailCalssification = atom({
    key: 'CostDetailCalssification',
    default:"",
});